var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8L8 0L16 4.8V6.4H0V4.8ZM0 14.4H16V16H0V14.4ZM1.6 12.8H14.4V14.4H1.6V12.8ZM1.6 6.4H4.8V12.8H1.6V6.4ZM6.4 6.4H9.6V12.8H6.4V6.4ZM11.2 6.4H14.4V12.8H11.2V6.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/companyIcon.f0e15e2b4ae1d660cb3c12ddcb7a3312.svg";
export { ForwardRef as ReactComponent };